import {Component, HostListener} from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonDirective } from 'primeng/button';

@Component({
    selector: 'install-prompt',
    templateUrl: './install-prompt.component.html',
    styleUrls: ['./install-prompt.component.scss'],
    imports: [DialogModule, ButtonDirective]
})
export class InstallPromptComponent{

	deferredPrompt: any;
	showPrompt = false;

	@HostListener('window:beforeinstallprompt', ['$event'])
	onbeforeinstallprompt(e) {
		console.log(e);
		// Prevent Chrome 67 and earlier from automatically showing the prompt
		e.preventDefault();
		// Stash the event so it can be triggered later.
		this.deferredPrompt = e;
		this.showPrompt = true;
	}


	installWings() {
		// hide our user interface that shows our A2HS button
		this.showPrompt = false;
		// Show the prompt
		this.deferredPrompt.prompt();
		// Wait for the user to respond to the prompt
		this.deferredPrompt.userChoice
			.then((choiceResult) => {
				if (choiceResult.outcome === 'accepted') {
					console.log('User accepted the A2HS prompt');
				} else {
					console.log('User dismissed the A2HS prompt');
				}
				this.deferredPrompt = null;
			});
	}
}

